export default __webpack_public_path__ + "static/media/material_icon.77def8a8.png";